import { useState } from "react";
import { LayoutGrid, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuLabel, DropdownMenuTrigger } from "@/components/ui/dropdown-menu";
import { useOperator } from "@/context/OperatorContext";
import { opApi, apiError } from "@/lib/api";

// One login, several Morr apps: MorrAccess mints a one-time launch link into the chosen app.
export function AppSwitcher() {
  const ctx = useOperator();
  const [busy, setBusy] = useState(null);
  const op = ctx?.operator;
  const apps = op?.app_list || [];
  if (!op || apps.length < 2) return null;

  const open = async (a) => {
    if (a.slug === op.app) return;
    setBusy(a.slug);
    try {
      const { data } = await opApi.post("/operator/switch-app", { product_key: a.product_key });
      window.location.href = data.url;
    } catch (e) {
      toast.error(apiError(e.response?.data?.detail) || "Couldn't open that app.");
      setBusy(null);
    }
  };

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="ghost" size="sm" className="rounded-none gap-2" data-testid="app-switcher-btn">
          {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : <LayoutGrid className="h-4 w-4" />}
          <span className="hidden sm:inline">Apps</span>
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="rounded-none" data-testid="app-switcher-menu">
        <DropdownMenuLabel className="text-xs text-muted-foreground">Switch app</DropdownMenuLabel>
        {apps.map((a) => (
          <DropdownMenuItem key={a.slug} onClick={() => open(a)} disabled={!!busy} data-testid={`app-switcher-item-${a.slug}`}>
            <span className="flex-1">{a.name}</span>
            {a.slug === op.app && <span className="text-[10px] uppercase tracking-wider text-muted-foreground ml-3">Current</span>}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
